import * as types from "./mutation-types";

export default {
  [types.SET_AREAS](state, payload) {
    state.areas = payload;
  },
  [types.SET_AREA](state, payload) {
    state.area = payload;
  },
  [types.SET_PAGINATION](state, payload) {
    state.pagination = payload;
  },
};
